import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ShortAnswerQandAComponent.css';
import { Collapse } from 'reactstrap';

class ShortAnswerQandAComponent extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      collapse: false
    };
  }

  static propTypes = {
    isBig: PropTypes.bool,
    qAndAInfo: PropTypes.shape({
      question: PropTypes.string.isRequired,
      questionType: PropTypes.string.isRequired,
      dateAsked: PropTypes.string,
      numberOfResponses: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      avgRating: PropTypes.number,
      responses: PropTypes.arrayOf(
        PropTypes.shape({
          percentage: PropTypes.number.isRequired,
          text: PropTypes.string.isRequired,
          answererEmails: PropTypes.array.isRequired,
          numberOfResponses: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        })
      ).isRequired,
      totalAttendees: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      uniqueRegistrantEmailsCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      totalQuestions: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      currentQuestionIndex: PropTypes.number.isRequired
    })
  };

  render() {
    const qAndAInfo = this.props.qAndAInfo;
    const isBig = this.props.isBig;
    const { t } = this.context;
    return (
      <div className="qAndAShortAnswer">
        <div className="qAndACard">
          <div className="qAndAHeader">
            <div>
              <span className="qAndACount">
                {t('engagement.questionsCount', {
                  currentQuestionIndex: qAndAInfo.currentQuestionIndex,
                  totalQuestions: qAndAInfo.totalQuestions
                })}
              </span>
              {isBig && <span> {qAndAInfo.question} </span>}
            </div>
            {!qAndAInfo.uniqueRegistrantEmailsCount && (
              <div>
                {t('engagement.attendeesRespondedCount', {
                  numberOfAttendeesResponded: qAndAInfo.numberOfResponses,
                  totalAttendees: qAndAInfo.totalAttendees
                })}
              </div>
            )}
            {qAndAInfo.uniqueRegistrantEmailsCount && (
              <div>
                {t('engagement.numberOfRegistrantsResponded', {
                  numberOfRegistrantsResponded: qAndAInfo.uniqueRegistrantEmailsCount
                })}
              </div>
            )}
          </div>
          <div className="qAndASubHeader">
            {!isBig && <div className="mobileQuestionAttribute"> {qAndAInfo.question} </div>}
            <span className="mobileQuestionTypeAttribute">{t('engagement.shortAnswerQuestionType')}</span>
          </div>

          <div className="shortAnsDashboard">{this.displayShortAnswers(qAndAInfo)}</div>
        </div>
      </div>
    );
  }

  displayShortAnswers = qAndAInfo => {
    const { t } = this.context;

    return (
      <div>
        {qAndAInfo.responses.slice(0, 2).map((item, index) => (
          <div className="shortAnsPanel" key={index}>
            <div className="shortAnswerText">{item.text}</div>
            <div className="displayEmails">{this.displayEmails(item.answererEmails)}</div>
            <hr className="lineBreak" />
          </div>
        ))}
        {!this.state.collapse &&
          qAndAInfo.responses.length > 2 && (
            <div className="collapsiblePanel" onClick={this.toggle}>
              {t('engagement.viewAllResponses')}
              <i className="togo-icon togo-icon-chevron togo-icon-2x customIcon" />
            </div>
          )}
        {qAndAInfo.responses.length > 2 && (
          <Collapse isOpen={this.state.collapse}>
            {qAndAInfo.responses.slice(2, qAndAInfo.responses.length).map((item, index) => (
              <div className="shortAnsPanel" key={index}>
                <div className="shortAnswerText">{item.text}</div>
                <div className="displayEmails">{this.displayEmails(item.answererEmails)}</div>
                <hr className="lineBreak" />
              </div>
            ))}
            <div className="collapsiblePanel" onClick={this.toggle}>
              {t('engagement.collapseQuestion')}
              <i className="togo-icon togo-icon-chevron togo-icon-2x togo-icon-rotate-180 customIcon" />
            </div>
          </Collapse>
        )}
      </div>
    );
  };

  toggle = () => this.setState(prevState => ({ collapse: !prevState.collapse }));

  displayEmails = email => {
    return email.map((item, index) => (
      <a href={`mailto:${item}`} key={index}>
        {item}
      </a>
    ));
  };
}

export default ShortAnswerQandAComponent;



// WEBPACK FOOTER //
// ./src/Components/ShortAnswerQandAComponent/ShortAnswerQandAComponent.js